import React from 'react';

interface DemoBadgeProps {
  label?: string;
}

export default function DemoBadge({ label = 'DEMO' }: DemoBadgeProps) {
  return (
    <span className="demo-watermark inline-flex items-center gap-1 px-2 py-0.5 rounded border border-[#a855f7]/30 bg-[#a855f7]/5">
      <span className="w-1 h-1 rounded-full bg-[#a855f7] inline-block" />
      {label}
    </span>
  );
}